import { Popup } from '../../../components/Popup'
import { Button, BUTTON_TYPES } from '../../../components/Button'
import { BTN_TXT } from '../../../constants'
import { Typography } from '../../../components/Typography'
import { useCRUDUserPopupProviderContext } from '../../../pages/CRUDUser/Provider/CRUDUserPopupProvider'
import { useCallback } from 'react'

type Props = {
  onDelete: () => void
  isMultiple: boolean
  onCancelCallback: () => void
}

export const DeleteContractCategoriesPopup = ({
  onDelete,
  isMultiple,
  onCancelCallback
}: Props) => {
  const {
    deleteCCPopup: {
      actions: { close },
      state: { visible, title }
    }
  } = useCRUDUserPopupProviderContext()

  const onCancel = useCallback(() => {
    close()
    onCancelCallback()
  }, [close, onCancelCallback])

  return (
    <Popup
      onCancel={onCancel}
      width={442}
      visible={visible}
      title={`${title as string}${isMultiple ? 'ies' : 'y'}?`}
      footer={
        <>
          <Button type={BUTTON_TYPES.DEFAULT} onClick={onCancel} upperCase>
            {BTN_TXT.CANCEL}
          </Button>
          <Button
            type={BUTTON_TYPES.PRIMARY}
            onClick={onDelete}
            upperCase
            danger
          >
            {BTN_TXT.DELETE}
          </Button>
        </>
      }
    >
      <Typography.Body1>
        {isMultiple ? 'Selected contract categories' : 'The contract category'}{' '}
        will be removed from the user’s profile. Do you want to proceed?
      </Typography.Body1>
    </Popup>
  )
}
